import "./top-authors.scss";
import Top from "components/app/project/top-authors/top";
import api from "api";
import { useParams } from "react-router-dom";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import { useQuery } from "hooks/query";
import { TopAuthorType } from "types";
import LeadingAuthors from "components/app/project/top-authors/widgets/leading-authors";
import ClipTray from "components/app/clip-tray";
import Pie from "components/app/project/top-authors/widgets/pie";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "redux/reducers";

function TopAuthors() {
    const query = useQuery();
    const params = useParams<any>();
    const [topAuthors, setTopAuthors] = useState<TopAuthorType[]>([]);
    const [authorFilter, setAuthorFilter] = useState<"Followers" | "Clips">("Followers");

    const getTopAuthors = async () => {
        const dateFrom = moment(query.get("datefrom"));
        const dateTo = moment(query.get("dateto"));
        const streams = query
            .get("streams")!
            .split(",")
            .map((x) => parseInt(x));
        const data = await api.topAuthors.getAll(params.projectId, dateFrom, dateTo, streams);
        setTopAuthors(data);
    };

    const onSetAuthorFilter = (val: "Followers" | "Clips") => {
        setAuthorFilter(val);
    };

    useEffect(() => {
        getTopAuthors();
    }, []);

    return (
        <>
            <div className="top-authors">
                <Top />
                <div className="body">
                    <div className="author-filter">
                        <div className={authorFilter === "Followers" ? "selected" : ""} onClick={() => onSetAuthorFilter("Followers")}>
                            By Followers
                        </div>
                        <div className={authorFilter === "Clips" ? "selected" : ""} onClick={() => onSetAuthorFilter("Clips")}>
                            By Clips
                        </div>
                    </div>
                    <LeadingAuthors authors={topAuthors} filter={authorFilter} />
                    <Pie authors={topAuthors} filter={authorFilter} />
                </div>
            </div>
            <ClipTray />
        </>
    );
}

export default TopAuthors;
